import { LANDING_PAGE_DOMAIN } from '@/services/constants';
import { BasicInput, Typography } from '@dev/ee-components';
import { Box, Grid } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

type Props = {
    subdomain: string;
    errorMsg: string;
    onChange(e: any): void;
};
const MAX_DOMAIN_LENGTH = 63;

const StyledCounter = styled(Grid)`
    margin-top: 4px;
    margin-bottom: 6px;
`;
const StyledDialog = styled.div`
    // white-space:pre-line;
`

export const AddLandingPageSubdomainDialogBody = ({ subdomain, errorMsg, onChange }: Props) => {
    const { t } = useTranslation();

    return (
        <StyledDialog>
            <Typography variant="body1" bodyVariant='onPaper' gutterBottom={true}>
                {t('landingpagessubdomain_desc')}
            </Typography>
            <Typography variant="body1" bodyVariant='onPaper' gutterBottom={true}>
                {t('landingpagessubdomain_desc2')}
            </Typography>
            <Box mb="24px" />
            <Grid container alignItems="baseline">
                <Grid item style={{ flex: 1 }}>
                    <BasicInput
                        fullWidth
                        onInput={onChange}
                        value={subdomain}
                        error={!!errorMsg}
                        errorMessage={errorMsg}
                    />
                    {!errorMsg && (
                        <StyledCounter container justifyContent="flex-end">
                            <Typography variant="body1" bodyVariant="help">{`${
                                subdomain?.length || 0
                            }/${MAX_DOMAIN_LENGTH}`}</Typography>
                        </StyledCounter>
                    )}
                </Grid>
                <Grid item style={{ height: 44, marginLeft: 4 }}>
                    <Typography variant="body1" bodyVariant="onPaper">{`.${LANDING_PAGE_DOMAIN}`}</Typography>
                </Grid>
            </Grid>
        </StyledDialog>
    );
};
